import { useUserListData } from 'Lib/hooks/useUserListData';
import PropTypes from 'prop-types';
import BOSFilterSelect from './index';

const UserSelect = ({
  onSelectUser,
  defaultSelectedId,
  userRoles,
  orgIds,
  excludedIds,
  placeholder = 'Select a User...',
  includedId,
  ...props
}) => {
  const filteredUserList = useUserListData({
    userRoles,
    orgIds,
    excludedIds,
    includedId,
  });

  return (
    <BOSFilterSelect
      listData={filteredUserList}
      labelField={'displayName'}
      searchField='full_name'
      onItemSelect={onSelectUser}
      placeholder={placeholder}
      defaultSelectedId={defaultSelectedId}
      fill
      {...props}
    />
  );
};

UserSelect.propTypes = {
  onSelectUser: PropTypes.func,
  defaultSelectedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  userRoles: PropTypes.array,
  orgIds: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.array,
  ]),
  excludedIds: PropTypes.array,
  placeholder: PropTypes.string,
  includedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onBlur: PropTypes.func,
};

export default UserSelect;
